import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
        <div className="buttons" >
        <a href={props.liveLink} target="_blank" >
        <button style={{width: '5rem', padding: '2px'}} className="btn primary-btn"> Live </button>
        </a>
              <a href={props.githubLink} target="_blank" >
                <button style={{width: '8rem', padding: '2px'}} className="btn highlighted-btn">Source Code</button>
                </a>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Work History", logoSrc: "work-history.svg" },
    { label: "Freelance History", logoSrc: "programming-skills.svg" },
    { label: "Skills", logoSrc: "projects.svg" },
    { label: "Projects", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "JavaScript", ratingPercentage: 85 },
    { skill: "React JS", ratingPercentage: 90 },
    // { skill: "React Native", ratingPercentage: 85 },
    { skill: "Express JS", ratingPercentage: 85 },
    { skill: "Node JS", ratingPercentage: 85 },
    { skill: "Mongo Db", ratingPercentage: 75 },
    { skill: "HTML", ratingPercentage: 80 },
    { skill: "CSS", ratingPercentage: 80 },
  ];

  const projectsDetails = [
    {
      title: "Educrates",
      duration: { fromDate: "2021", toDate: "2021" },
      description:
        "Educrates Is An Educational Web Application That Specialises In Providing Academic Resources Through Computer Aided Learning That Are Catered Towards Students Who Have Been Diagnosed With Autism Or ADHD",
      subHeading: "Technologies Used: React JS, Redux, JavaScript, CSS, Firebase-Auth",
      liveLink:"https://educrate-resources.netlify.app/",
      githubLink:"https://github.com/usama-mk/educrates-resources"
    },
    {
      title: "Flama",
      duration: { fromDate: "2021", toDate: "2021" },
      description:
        "Flama where you present yourself- modling",
      subHeading:
        "Technologies Used:  React JS, HTML, CSS",
        liveLink:"https://flama-0.netlify.app/",
        githubLink:"https://github.com/usama-mk/flama"
    },
    {
      title: "Coin Plant",
      duration: { fromDate: "2022", toDate: "2022" },
      description:
        "Coin Plants are a collection of 2500 randomly generated pixel art NFTs that are sprouting up on the Ethereum blockchain.",
      subHeading:
        "Technologies Used: React Js, Tailwind Css",
        liveLink:"https://coin-plants.netlify.app/",
        githubLink:"https://github.com/usama-mk/coin-planets"
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"COMSATS University, Islamabad, Pakistan"}
        subHeading={"BS SOFTWARE ENGINEERING"}
        fromDate={"2018"}
        toDate={"2022"}
      />

      <ResumeHeading
        heading={"Peace College"}
        subHeading={"Pre-Engineering"}
        fromDate={"2015"}
        toDate={"2017"}
      />
      <ResumeHeading
        heading={"High School "}
        subHeading={"APSACS Akora Khattak"}
        fromDate={"2003"}
        toDate={"2015"}
      />
    </div>,

    /* WORK EXPERIENCE */
    <div className="resume-screen-container" key="work-experience">
      <div className="experience-container">
        <ResumeHeading
          heading={"Tamba Technologies"}
          subHeading={"Jr. FULL STACK ENGINEER"}
          fromDate={"2022"}
          toDate={"2022"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            Worked as MERN stack web developer.
          </span>
        </div>
        <div className="experience-description">
          <span className="resume-description-text">
            - Developed an and contributed in a team for a website for client with the dashboard for
            managing the products, managing reviews, users, payment etc.
          </span>
          <br />
          <span className="resume-description-text">
            - Integrated the web app with backend services to create new user
            onboarding application with dynamic form content.{" "}
          </span>
          <br />
          <span className="resume-description-text">
            - I stretched my mental capacity to develope UI as per the given
            designs.
          </span>
          <br />
        </div>
      </div>
    </div>,
      /* WORK EXPERIENCE 2 */
      <div className="resume-screen-container" key="work-experience">
      <div className="experience-container">
        <ResumeHeading
          heading={"Fiverr Level 2"}
          subHeading={"FULL STACK ENGINEER"}
          fromDate={"2020"}
          toDate={"Present"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            Working as MERN stack web developer.
          </span>
        </div>
        <div className="experience-description">
          <span className="resume-description-text">
            - Developed an and worked on more than 150 projects for clients with different requirements.
          </span>
          <br />
          <span className="resume-description-text">
            - Integrated the web app with backend services to create new user
            onboarding application with dynamic form content.{" "}
          </span>
          <br />
          <span className="resume-description-text">
            - Developed responsive UI in react js with pixel perfect results
          </span>
          <br />
        </div>
      </div>
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
          liveLink={projectsDetails.liveLink}
          githubLink={projectsDetails.githubLink}
          
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Leading"
        description="Apart from being a tech enthusiast and a code writer, i also love to lead people what i know simply because i believe in showing and encouringing the right path."
      />
      <ResumeHeading
        heading="Music"
        description="Listening to soothing music is something i can never compromise with, skimming through Spotify's pop songs charts is at times the best stress reliever that i can get my hands on."
      />
      <ResumeHeading
        heading="Competitive Gaming"
        description="I like to challenge my reflexes a lot while competing in football games, pushing the rank and having interactive gaming sessions excites me the most."
      />
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`).default}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div className="resume-container screen-container " id={props.id || ""}>
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
